/**
 * @flow
 * @relayHash 494d80fb0f903b736ddbd454558a3d81
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteWarehouseLocationInput = {|
  id: string
|};
export type DeleteWarehouseLocationMutationVariables = {|
  input: DeleteWarehouseLocationInput
|};
export type DeleteWarehouseLocationMutationResponse = {|
  +deleteWarehouseLocation: {|
    +warehouseLocationEdge: {|
      +cursor: string,
      +node: {|
        +id: string
      |},
    |}
  |}
|};
export type DeleteWarehouseLocationMutation = {|
  variables: DeleteWarehouseLocationMutationVariables,
  response: DeleteWarehouseLocationMutationResponse,
|};
*/


/*
mutation DeleteWarehouseLocationMutation(
  $input: DeleteWarehouseLocationInput!
) {
  deleteWarehouseLocation(input: $input) {
    warehouseLocationEdge {
      cursor
      node {
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteWarehouseLocationInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteWarehouseLocation",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteWarehouseLocationPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "warehouseLocationEdge",
        "storageKey": null,
        "args": null,
        "concreteType": "WarehouseLocationEdge",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "cursor",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "WarehouseLocation",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteWarehouseLocationMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteWarehouseLocationMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteWarehouseLocationMutation",
    "id": null,
    "text": "mutation DeleteWarehouseLocationMutation(\n  $input: DeleteWarehouseLocationInput!\n) {\n  deleteWarehouseLocation(input: $input) {\n    warehouseLocationEdge {\n      cursor\n      node {\n        id\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '472878ca1a19a0b2f38a8af2e1ea53c0';
module.exports = node;
